import React, { useState } from 'react';
import { ReactComponent as UserIcon } from '../../Assets/Icons/usernamicon.svg';
import { ReactComponent as PasswordIcon } from '../../Assets/Icons/passwordicon.svg';
import { ReactComponent as PhoneIcon } from '../../Assets/Icons/phoneicon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../Storeredux/reducers/rootReducer';
import { Auth } from '../../Storeredux/constants/actionTypes';
import CustomButton from '../Form/CustomButton';
import { areAllKeysFilled } from '../../Utils/formValidator';
import { ArrowLeft, Eye, EyeSlash } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';
import { handleChangeSteps, handleCreateEmployeeRequest } from '../../Storeredux/actions';


function UpdateEmployee({ next, email }: any) {
  const AuthState = useSelector((state: RootState) => state.auth as Auth);
  const { loading, email: hhhh, companyId } = AuthState;
  console.log(hhhh);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState({
    'firstname': '',
    'lastname': '',
    'password': '',
    'phone_number': '',
  });
  const [errorState, setErrorState] = useState({
    phone: '',
    alternative_phone: '',
  });
  const isFormComplete = areAllKeysFilled(data);
  console.log(data, email);

  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(prevState => !prevState);
  };

  const validatePhoneNumber = (phoneNumber: string) => {
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    const expectedLength = 11;
    if (digitsOnly.length === expectedLength) {
      setData({ ...data, phone_number: phoneNumber });
      setErrorState({ ...errorState, phone: '' });
    } else {
      setErrorState({ ...errorState, phone: 'Invalid Phone Number' });
    }
  };

  const setOnChange = (e: any) => {
    if (e.target.name === 'phone_number') {
      validatePhoneNumber(e.target.value);
      return;
    }

    setData({ ...data, [e.target.name]: e.target.value });
  };
  const handleSubmit = () => {
    setErrorState({ ...errorState, phone: '' });
    const payloadData = {
      'name': data.firstname + ' ' + data.lastname,
      'email': hhhh,
      'password': data.password,
      'phone_number': data.phone_number,
      'company_id': companyId,
    };
    console.log(payloadData, hhhh, companyId);
    dispatch(handleCreateEmployeeRequest({ payload: payloadData, navigate: navigate }));
  };


  return (
    <>
      <div
        className={`${next === 'create' ? '' : 'hidden'} bg-white rounded-xl md:h-3/4 xl:h-fit md:w-6/12 lg:w-5/12 xl:w-4/12 w-11/12 overflow-auto border border-input-color my-8`}
        style={{ boxShadow: '0px 2px 8px 2px #8C8C8C1A' }}>

        <form autoComplete="off" className='p-7 bg-white'>
          <div>
            <span onClick={() =>  dispatch(handleChangeSteps({ steps: 'email' }))} >
              <ArrowLeft size="24" color="black"/>
            </span>
          </div>
          <div className='flex gap-1.5 items-center'>
            <h3 className='font-semibold text-2xl'>
              Information Details
            </h3>
          </div>

          <div className={'gap-3.5'}>
            <div className='py-4'>
              <label className='font-semibold text-sm block pb-2'>
                First name
              </label>
              <div className="relative">
                <UserIcon
                  className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                <input autoComplete='off' name='firstname' onChange={setOnChange} required
                       className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-custom"
                       type="text" placeholder="Enter your first name" />
              </div>
            </div>
          </div>
          <div className='pb-3'>
            <label className='font-semibold text-sm block pb-2'>
              Last name
            </label>
            <div className="relative">
              <UserIcon
                className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
              <input autoComplete='off' name='lastname' onChange={setOnChange} required
                     className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-custom"
                     type="text" placeholder="Enter your last name" />
            </div>
          </div>
          <div className={'gap-3.5 pb-3'}>
            <div className='pb-1'>
              <label className='font-semibold text-sm block pb-2'>
                Phone Number
              </label>
              <div className="relative">
                <PhoneIcon
                  className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                <input autoComplete='off' name='phone_number' onChange={setOnChange} required
                       className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-custom"
                       type="text" placeholder="Enter your phone number" />
              </div>
            </div>
            {errorState.phone && (
              <div className="text-red-500 text-xs mt-1">
                {errorState.phone}
              </div>
            )}
          </div>
          <div className='pb-3'>
            <label className='font-semibold text-sm block pb-2'>
              Password
            </label>
            <div className="relative">
              <PasswordIcon
                className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
              <input name="password" onChange={setOnChange} required
                     className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-custom"
                     type={isPasswordVisible ? 'text' : 'password'} placeholder="Password" />
              <span
                onClick={togglePasswordVisibility}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
              >
                    {isPasswordVisible ? <Eye size="20" color="#8E8E93" /> : <EyeSlash size="20" color="#8E8E93" />}
                  </span>
            </div>
          </div>

          <div className="flex justify-center">
            <CustomButton
              isLoading={loading}
              disabled={!isFormComplete}
              children={'Create'}
              onClick={handleSubmit}
              className='text-sm md:text-md w-1/2 pt-3 mt-3.5 bg-custom-darkgreen text-white font-semibold rounded-custom py-2'
            />
          </div>
          {/*<div className='text-center py-3 text-xs'>*/}
          {/*  <p>Already have an account? <Link to='/login'*/}
          {/*    className='font-semibold text-custom-green'>Login</Link></p>*/}
          {/*</div>*/}
        </form>
      </div>
    </>
  );
}

export default UpdateEmployee;
